export const FETCH_USER_SUCCESS = "FETCH_USER_SUCCESS";

export const LOGIN_SUCCESS = "LOGIN_SUCCESS";

export const DRAGGED_ITEM = "DRAGGED_ITEM"
export const RELATIVE_DISTANCE = "RELATIVE_DISTANCE"
export const RETRIEVED_ITEM = "RETRIEVED_ITEM"

export const LOGOUT = "LOGOUT";